/**
 *
 * @class FontStyle
 *
 * the kinds of font style
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export enum FontStyle {
  NORMAL  = '',
  ITALIC  = 'italic',
  OBLIQUE = 'oblique'
}
